import { HotkeyType, useHotkey, useTranslation } from '@threatadvisor/react-utils';
import { Button, ButtonProps, Row, Space } from 'antd';
import React, { ReactElement } from 'react';

type SaveButtonProps = {
  saving?: boolean;
  disabled?: boolean;
  onSave: () => void;
  onCancel: () => void;
  style?: React.CSSProperties;
  saveButtonLabel?: string;
  saveButtonProps?: Omit<ButtonProps, 'onClick'>;
};

/*
 * Provides Save and Cancel buttons to be used in a Modal, with support for hotkeys (escape to cancel, ctrl-enter to save)
 */
export default function SaveButtons(props: SaveButtonProps): ReactElement {
  const { onSave, onCancel, disabled, saving, style, saveButtonLabel, saveButtonProps } = props;
  const { t } = useTranslation();

  useHotkey(HotkeyType.PRIMARY, onSave);
  useHotkey(HotkeyType.CANCEL, onCancel);

  return (
    <Row justify="end" style={style}>
      <Space>
        <Button disabled={saving} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          cy-test="save-button"
          type="primary"
          disabled={saving || disabled}
          loading={saving}
          onClick={onSave}
          {...saveButtonProps}
        >
          {saveButtonLabel ?? t('labels.save', 'Save')}
        </Button>
      </Space>
    </Row>
  );
}
